<div class="hidden" aria-hidden="true">
  <div lStatusTooltip></div>
</div>

<l-list-container
  class="users-list-table"
  [size]="size"
  [page]="page"
  [data]="data"
  [sort]="sort"
  [total]="total"
  [isLoading]="isLoading"
  (onPage)="pageChange.emit($event)"
  (onSort)="sortChange.emit($event)"
>
  <ng-template #header>
    <th lSortable="name">Nome</th>
    <th lSortable="email">E-mail</th>

    @if (hasSSO) {
      <th lSortable="status">
        <span class="inline-flex items-center gap-1.5">
          Status
          <l-icon
            class="!text-base opacity-60 hover:opacity-100 transition-opacity"
            [pTooltip]="statusTooltip"
            tooltipPosition="bottom"
            tooltipStyleClass="status-info-tooltip"
            (click)="$event.stopPropagation()"
          >info</l-icon>
        </span>
      </th>
    } @else {
      <th lSortable="sector">Setor</th>
      <th lSortable="position">Cargo</th>
      <th lSortable="status">Status</th>
    }
    
    
    <th lSortable="updatedAt">Último acesso</th>
    <th class="w-12"></th>
  </ng-template>

  <ng-template #statusTooltip>
    <div lStatusTooltip></div>
  </ng-template>

  <ng-template #body let-u>
    <td>
      <div class="flex items-center gap-3">
        <l-avatar [name]="u.name" [imageUrl]="u.imageUrl" />
        <span>{{ u.name }}</span>
      </div>
    </td>

    <td>{{ u.email || '—' }}</td>

    @if (hasSSO) {
      <td>
        <l-status-pill [status]="getUserStatus(u)" />
      </td>
    } @else {
      <td>{{ u.sector || '—' }}</td>
      <td>{{ u.position || '—' }}</td>
      <td>
        <l-status-pill [status]="getUserStatus(u)" />
      </td>
    }

    <td>{{ u.updatedAt ? (u.updatedAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td>
      <button
        class="flex h-7 w-7 items-center justify-center rounded text-lGray600 hover:bg-lGray700/70 hover:text-lWhite transition-colors"
        (click)="rowMenu.toggle($event)"
      >
        <l-icon icon="more_vert" />
      </button>

      <l-modal-actions #rowMenu [actions]="getRowActions(u)" />
    </td>
  </ng-template>
</l-list-container>
